var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "700" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "p-0" },
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c(
                "v-flex",
                { attrs: { xs9: "" } },
                [
                  _c("v-icon", [_vm._v("done")]),
                  _vm._v("Aprobar CAS\n\t\t\t\t")
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c(
                "v-container",
                {
                  staticStyle: { "min-width": "100%" },
                  attrs: { "grid-list-md": "" }
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "", row: "" } },
                    [
                      _c("v-flex", { attrs: { xs12: "", md12: "" } }, [
                        _c("h3", { staticClass: "detalle" }, [
                          _c("strong", [_vm._v("Nombres : ")]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.form.nombres) +
                              "  " +
                              _vm._s(_vm.form.ap_paterno) +
                              "  " +
                              _vm._s(_vm.form.ap_materno) +
                              "\n              "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { xs12: "", md12: "" } }, [
                        _c("h3", { staticClass: "detalle" }, [
                          _c("strong", [_vm._v("Ítem : ")])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { xs12: "", md12: "" } }, [
                        _c("h3", { staticClass: "detalle" }, [
                          _c("strong", [
                            _vm._v("Fecha de presentación en ASP-B:  ")
                          ]),
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.form.fecha_presentacion) +
                              "\n              "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { xs12: "", md12: "" } }, [
                        _c("h3", { staticClass: "detalle" }, [
                          _c("strong", [
                            _vm._v("Años de calificación a la fecha :")
                          ]),
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.form.anios) +
                              "\n              "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { xs12: "", md12: "" } }, [
                        _c("h3", { staticClass: "detalle" }, [
                          _c("strong", [
                            _vm._v("Meses de calificación a la fecha :")
                          ]),
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.form.meses) +
                              "\n              "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { xs12: "", md12: "" } }, [
                        _c("h3", { staticClass: "detalle" }, [
                          _c("strong", [
                            _vm._v("Días calificados a la fecha :")
                          ]),
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.form.dias) +
                              "\n              "
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [
                  _c("v-icon", [_vm._v("cancel")]),
                  _vm._v(" " + _vm._s(_vm.$t("common.cancel")) + "\n\t\t\t\t\t")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "rgb(80,38,217)",
                    dark: "",
                    type: "submit",
                    loading: _vm.loading
                  },
                  on: {
                    click: function($event) {
                      return _vm.aprobarCas()
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { dark: "" } }, [_vm._v("check")]),
                  _vm._v(" APROBAR\n\t\t\t\t\t")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a18b56f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a18b56f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/lista_personal_cas/dialogs/AprobarCas.vue
// module id = null
// module chunks = 